import { Number } from "components/common"
import { FRACTIONAL_PAYMENT_CHANNEL_STANDARD } from "../fractionalPaymentUtils"

/** Client profile fields that must be present before opening the fractional sale flow */
export const FRACTIONAL_SALE_CLIENT_REQUIRED_FIELDS = [
  "dateOfBirth",
  "relationship",
  "nationalId",
  "countryId",
  "cityId",
  "localityId",
  "email",
  "name",
]

export const FRACTIONAL_SALE_DEFAULT_FORM_VALUES = {
  blockCount: 1,
  fractionalPaymentChannel: FRACTIONAL_PAYMENT_CHANNEL_STANDARD,
  payments: [{ enableDepositRA: false }],
}

export function isPaymentProofVisionOnProject(value) {
  if (value == null || value === "") return false
  if (typeof value === "boolean") return value
  if (typeof value === "number") return value !== 0
  const s = String(value).toLowerCase()
  return s === "1" || s === "true" || s === "on" || s === "yes"
}

export function formatFractionalSaleAmount(value) {
  if (value == null || value === "") return "-"
  return <Number value={value} isCurrency tooltip className="bold" compact="" />
}

export function partnerFeeTotalFromFeeData(psidFeeData) {
  if (psidFeeData == null) return 0
  const n = +psidFeeData?.partnerFeeTotal
  return n ?? 0
}

export function taxTotalFromFeeData(psidFeeData) {
  if (psidFeeData == null) return 0
  return Math.round(+psidFeeData?.taxTotal ?? 0)
}

function isRaFlowEnabledFlag(v) {
  return v === true || v === 1 || String(v) === "1" || String(v) === "true"
}

export function isRaFlowEnabledForFractionalProject(projectDetail, blockData, selectedFractionalProject) {
  return [
    projectDetail?.isRAFlowEnabled,
    projectDetail?.Project?.isRAFlowEnabled,
    blockData?.isRAFlowEnabled,
    selectedFractionalProject?.isRAFlowEnabled,
  ].some(isRaFlowEnabledFlag)
}

export function isPaymentProofOcrEnabledForFractionalProject(projectDetail, blockData, selectedFractionalProject) {
  const nested = projectDetail?.Project
  return [
    projectDetail?.paymentProof,
    nested?.paymentProof,
    blockData?.paymentProof,
    selectedFractionalProject?.paymentProof,
  ].some(isPaymentProofVisionOnProject)
}

export function computeFractionalBlocksTotal(blockData, blockCount) {
  if (!blockData) return 0
  return (+blockData.pricePerBlock || 0) * +blockCount
}

export function computeFractionalGrandTotal({ blockData, blocksTotal, taxTotal, partnerFeeTotal, processingFee }) {
  if (blockData == null) return 0
  return blocksTotal + (+taxTotal || 0) + partnerFeeTotal + (+processingFee || 0)
}

export function canFetchFractionalPartnerFees({ clientId, projectId, blockCount }) {
  return (
    clientId != null &&
    clientId !== "" &&
    projectId != null &&
    projectId !== "" &&
    blockCount != null &&
    +blockCount > 0
  )
}

export function findSelectedFractionalProject(projectOptions, projectId) {
  return (projectOptions || []).find(o => String(o?.value) === String(projectId))
}

export function isFractionalPaymentTotalMatchingGrand(grandTotal, firstPaymentAmount) {
  const ref = Math.round(+grandTotal || 0)
  const sum = Math.round(+(firstPaymentAmount || 0))
  return ref > 0 && sum === ref
}
